import fetch                         from '../../../utils/browser-fetch';
import { setUserData }               from '../../../user-dux';
import { setUserLocale }             from '../profile/profile-dux';
import { fetchBundleData }           from '../../../client-dux';
import { preActivationLoginAttempt } from '../activation/activation-dux';
import busyActionFactory             from '../../../busy';
import { addError }                  from '../../../errors-dux';
import Errors                        from '../../../errors';


/*******************************************************************************
 * Initial state
 */
const initialState = {
    busy: false,
    busyLaunchAs: false,
    authenticated: false
};


/*******************************************************************************
 * Non-async action types
 */
export const BUSY_LOGIN = 'BUSY_LOGIN';
export const BUSY_LAUNCH_AS = 'BUSY_LAUNCH_AS';


/*******************************************************************************
 * Reducer
 */
export default function loginData( state = initialState, action ) {
    switch ( action.type ) {

        case BUSY_LOGIN:
            return {
                ...state,
                busy: action.busy
            };

        case BUSY_LAUNCH_AS:
            return {
                ...state,
                busyLaunchAs: action.busy
            };

        default:
            return state;
    }
}


/*******************************************************************************
 * Action creators
 */
const busyLogin = busyActionFactory( BUSY_LOGIN );
export function login( username, password ) {

    return ( dispatch, getState ) => {
        dispatch( busyLogin( true ) );

        const state = getState();

        return fetch( '/api/v1.0/login', {
                method: 'post',
                body: { username: username, password: password }
            } )
            .then( ( userData ) => {
                if ( !userData.locale.code ) {
                    userData.locale = { ...state.clientData.locale };
                }

                const setUserLocaleFlag = state.userData.locale.code !== state.clientData.locale.code && state.userData.locale.code !== userData.locale.code;
                const userSelectedLocale = state.userData.locale.code;
                const fetchBundleDataFlag = JSON.parse( sessionStorage.getItem( 'bundleState' ) ).bundleList[ userData.locale.code ];

                if ( !fetchBundleDataFlag ) {
                    dispatch( fetchBundleData( userData.locale.code ) )
                        .then( () => {
                            dispatch( busyLogin( false ) );
                            userData.authenticated = true;
                            userData.ssoAuthenticated = false;
                            dispatch( setUserData( userData ) );
                            setUserLocaleFlag && dispatch( setUserLocale( userSelectedLocale ) );
                        } );
                } else {
                    dispatch( busyLogin( false ) );
                    userData.authenticated = true;
                    dispatch( setUserData( userData ) );
                    setUserLocaleFlag && dispatch( setUserLocale( userSelectedLocale ) );
                }
            } )
            .catch( ( error ) => {
                dispatch( busyLogin( false ) );
                if ( error.errorCode === 20013 ) {
                    dispatch( preActivationLoginAttempt( true, error.responseMessage ) );
                } else {
                    dispatch( addError( error, Errors.ERROR_LOGIN ) );
                }
            } );
    };
}

const busyLaunchAs = busyActionFactory( BUSY_LAUNCH_AS );
export function launchAs() {
    return ( dispatch, getState ) => {
        const state = getState();

        dispatch( busyLaunchAs( true ) );

        if ( window.location.search.length === 0 ) {
            dispatch( addError( new Error( 'No login token' ), Errors.ERROR_LOGIN ) );
        }
        const token = window.location.search.substring( 1 );

        return fetch( '/api/v1.0/launchAs', {
                method: 'post',
                body: { token }
            } )
            .then( ( userData ) => {
                if ( !userData.locale.code ) {
                    userData.locale = { ...state.clientData.locale };
                }

                const fetchBundleDataFlag = JSON.parse( sessionStorage.getItem( 'bundleState' ) ).bundleList[ userData.locale.code ];

                if( !fetchBundleDataFlag ) {
                    dispatch( fetchBundleData( userData.locale.code ) )
                        .then( () => {
                            dispatch( busyLaunchAs( false ) );
                            userData.authenticated = true;
                            userData.adminAsUser = true;
                            dispatch( setUserData( userData ) );
                        } );
                } else {
                    dispatch( busyLaunchAs( false ) );
                    userData.authenticated = true;
                    userData.adminAsUser = true;
                    dispatch( setUserData( userData ) );
                }
            } )
            .catch( ( error ) => {
                dispatch( busyLaunchAs( false ) );
                dispatch( addError( error, Errors.ERROR_LOGIN ) );
            } );
    };
}
